import React from 'react';
import {
  PinIcon,
  PinOutlineIcon,
  TrashIcon,
} from '../../../../components/Icons';

interface SavedFilterItemProps {
  id: string;
  text: string;
  pinned: boolean;
  onClick: (text: string) => void;
  onPinClick?: (id: string) => void;
  onTrashClick?: (id: string) => void;
  showPinAndTrash?: boolean;
}
const SavedFilterItem = ({
  id,
  text,
  pinned,
  onClick,
  onPinClick,
  onTrashClick,
  showPinAndTrash = true,
}: SavedFilterItemProps) => {
  return (
    <div className="search-item-container">
      <div className="search-item" onClick={() => onClick(id)}>
        {text}
      </div>
      {showPinAndTrash && (
        <>
          <button
            onClick={() => {
              if (onPinClick) {
                onPinClick(id);
              }
            }}
          >
            {pinned ? <PinIcon /> : <PinOutlineIcon />}
          </button>
          <button
            onClick={() => {
              if (onTrashClick) {
                onTrashClick(id);
              }
            }}
          >
            <TrashIcon />
          </button>
        </>
      )}
    </div>
  );
};

export default SavedFilterItem;
